import { ImgHTMLAttributes } from 'react';
import { getFilePath } from '@rootCommon/utilities';
import { user } from '@rootCommon/images';
import { IdType } from '@rootCommon/types/common';
import { cn } from '@rootCommon/lib/classname';

type Props = {
  fileId?: IdType | null;
};

const formCn = cn('avatar');

const Avatar = ({ fileId, className, ...restProps }: Props & ImgHTMLAttributes<HTMLImageElement>): JSX.Element => {
  const avatarSrc = fileId ? getFilePath(fileId) : user;

  return (
    <div className={formCn('container', [className])}>
      <img src={avatarSrc} alt="" {...restProps} />
    </div>
  );
};

export default Avatar;
